import { ReactNode } from 'react';
import { useLogger } from '@packages/shared/core/common/hooks';
import { useQuizStep } from '@packages/shared/core/quiz/hooks';
import { QuizScreenProps, TestimonialStepData } from '@packages/shared/core/quiz/entities';

type TestimonialQuizStepProps = {
  id: string;
  renderQuizScreen: (stepData: QuizScreenProps) => ReactNode;
};

const TestimonialQuizStep = ({ id, renderQuizScreen }: TestimonialQuizStepProps) => {
  const logger = useLogger();
  const { back, next, stepData } = useQuizStep(id);

  if (!stepData) {
    // TODO add fallback
    logger.error(new TypeError(`Data for ${id} step not found`));
    return null;
  }

  const goBack = async () => back();

  const onContinue = async () => next();

  return (
    <>
      {renderQuizScreen({
        onContinue,
        onBack: goBack,
        ...(stepData as TestimonialStepData),
      })}
    </>
  );
};

export default TestimonialQuizStep;
